import 'core-js/fn/object/assign';
import 'whatwg-fetch';

import Promise from 'promise-polyfill';

// To add to window
if (!window.Promise) {
  window.Promise = Promise;
}

import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/Main';


// Render the main component into the dom
ReactDOM.render(<App />, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js